import {Component, Input, Output, EventEmitter} from '@angular/core';

@Component({
  selector: 'general-info-panel',
  templateUrl: './general-info.component.html',
  styleUrls: ['./general-info.component.css']
})
export class GeneralInfoComponent{

  @Input() header = "";
  @Input() id;
  @Input() collapsed = false;
  @Output() collapsedChange: EventEmitter<boolean>;
  @Input() visible = false;
  @Input() facilityGeneralInfo = null;



  constructor() {
    this.collapsedChange = new EventEmitter<boolean>();
  }

  onClick() {
    this.collapsedChange.emit(!this.collapsed);
  }

}



// WEBPACK FOOTER //
// ./src/app/profile/panels/general-info/general-info.component.ts